class HTML {
    //get html as text to be used by 
    //import Parser from "html-react-parser";

    //https://www.w3schools.com/tags/tryit.asp?filename=tryhtml_td_width_css
	static makeTable(arr2D,width,hasHeader) {
        //table_fixFirstWidth([['Month','Sales'],['January','100'],['February','80']],['70%','30%'],true);
        if(hasHeader == null){ hasHeader = false;}
        var output = "<table style='width:100%'>";
        for (var i = 0; i < arr2D.length; i++) { 
            output += "<tr>";
            for (var j = 0; j < arr2D[i].length; j++) { 
                if(i == 0 && hasHeader){
                    output += "<th";
                }
                else{
                    output += "<td";
                }
                if(i == 1 && hasHeader){
                    output += " style={{minWidth:" + width[j] + "}}"
                }
                output += ">";
                output += arr2D[i][j];
                if(i == 0 && hasHeader){
                    output += "</th>";
                }
                else{
                    output += "</td>";
                }
            }            
            output += "</tr>";
        }
        output += "</table>"
        return output;
	}

    static makeBullet(arr) {
        var output = "<ul>";
        for (var i = 0; i < arr.length; i++) { 
            output += "<li>" + arr[i] + "</li>";
        }
        output += "</ul>"
        return output;
	}


}
export default HTML;
